import React from 'react';
import { Helmet } from 'react-helmet';

function Onboarding_FAQ_Seo() {
  return (
    <div>
       <Helmet>
                <title>General FAQs | Pay Quik</title>
                <meta name="keywords" content="" />
                <meta name="description" content="" />
                <meta property="og:title" content="General FAQs | Pay Quik" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="https://pay-quik.co.uk/assets/images/logo/site-logo.png" />
                <meta property="og:url" content="https://pay-quik.co.uk/onboarding_faq" />
                <meta name="twitter:title" content="General FAQs | Pay Quik" />
                <meta name="twitter:description" content="" />
                <meta name="twitter:image" content="https://pay-quik.co.uk/assets/images/logo/site-logo.png" />
            </Helmet>
    </div>
  )
}

export default Onboarding_FAQ_Seo
